/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {ColumnState} from 'ag-grid-community';
import {Action} from 'redux';
import {ThunkDispatch} from 'redux-thunk';
import {ServiceError} from '@ion/core/src/types/services';

// [APPLICATIONS PACKAGE TODO]: The re-exports from admin-users state need to
// be removed as this violates our export rules. Temporarily allowing these
// re-exports until refactoring is planned.

// eslint-disable-next-line no-barrel-files/no-barrel-files
export * from '../pages/admin/users/state';

/**
 * Defines the generic Redux Store Interface. Note, this is essentially just
 * a marker interface to denote a type as the entire application store.
 *
 * Concrete store implementations can extend iOnApplicationStore if they wish
 * to dynamically define reducer types without the need explicitly add each
 * reducer and it's type. Otherwise, IApplicationStore should be implemented
 * directly.
 */
export interface IApplicationStore {
};

export interface iOnApplicationStore extends IApplicationStore {
  [key: string]: any;
};

// defines the default redux async action creator type ...
export type AsyncActionCreator = ThunkDispatch<Function, Function, null>;

// defines the default page initialization redux action creator type ...
export interface PageInitializeAction extends Action {
};

export interface AsyncState {
  loading: boolean;
  error: ServiceError | null;
};

export interface AsyncGridState extends AsyncState {
  columnState: ColumnState[]
}

export interface AdminAction {
  type: string;
  result?: any;
  error?: ServiceError;
  show?: boolean;
  edit?: boolean;
  view?: boolean;
};

// defines the report type.
export enum ReportType {
  detail = 'detail',
  summary = 'summary'
}

export enum ExportContext {
  asset = 'asset',
  device = 'device',
  user = 'user',
  account = 'account',
  groups = 'groups',
  notification = 'notification',
  notificationType = 'notificationType',
  role = 'role',
  reports = 'reports',
  assetHistory = 'assetHistory',
  jobStatus = 'jobStatus',
  taskStatus = 'taskStatus',
  eventHistory = 'eventHistory',
  devicePassword = 'devicePassword',
  downloadJobs = 'downloadJobs',
  jobSearchEngine = 'jobSearchEngine',
  jobs = 'job',
  crashboxx = 'crashboxx',
  videoEvents = 'videoEvents',
  visionRequests = 'visionRequests',
  deviceFiles = 'deviceFiles',
  movedDevices = 'movedDevices',
  movedAssets = 'movedAssets',
  inventoryDevices = 'provisionedDevices',
  applicationIds = 'applicationsIds',
  uploadManufacturedDevices = 'uploadManufacturedDevices',
  devicePartNumbers = 'devicePartNumbers',
  manufacturedDevices = 'manufacturedDevices',
  shipments = 'shipments',
  filemeta = 'filemeta'
}
